import http from "./api";

const userApi = {
  getMe: (credentials?: BasicCredential) => http.get<UserMe>("users/me", { headers: { Authorization: credentials ? `Basic ${btoa(credentials.login + ':' + credentials.password)}` : "", } }),
  getImpersonatedAs: () => http.get<UserMe>(`users/impersonated-as`),
  getMeFromLoginLink: (loginLink: string) => http.get<UserMe>("users/me", { headers: { "X-Magic-Link": loginLink } }),
  updateMe: (data: Partial<UserMe>) => http.put<UserMe>("users/me", data),
  canLogBySMS: (email: string) => http.get<boolean>(`users/check-sms-eligibility/${email}`),
  canLogByEmail: (email: string) => http.get<boolean>(`users/check-email-eligibility/${email}`),
  sendLoginLink: (email: string) => http.post<void>(`users/email-link/${email}`),
  sendEmailLoginCode: (email: string) => http.post<void>(`users/email-code/${email}`),
  sendSMSLoginCode: (email: string) => http.post<void>(`users/sms-code/${email}`),
  logout: () => http.post<void>("users/logout"),

  settings: () => http.get<UserSetting[]>('settings/user'),
  getBanners: () => http.get<UserBanner[]>('banners/user'),
};

export default userApi;
